import EventBus from "./event-bus";
import {errorHandler} from "./utils";

const axios = require('axios');

export function getDriverOrderList(date, listOnly) {
  return new Promise(function(resolve, reject) {
    console.log("place order " + localStorage.getItem("JSTOKEN"));
    EventBus.$emit("showLoading", true);
    axios.get(process.env.ROOT_API + 'driver/orders?date=' + date + '&listOnly=' + listOnly, {
      headers:{
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function(response) {

      let data = response['data'];
      console.log(data);
      resolve(data);
    })
      .catch(error=>{
        EventBus.$emit("showLoading", false);
        console.log("error to update");
        console.log(error.response);
        if(error.response != undefined && error.response.data != undefined && error.response.data.status != undefined && error.response.data.status == 403) {
          EventBus.$emit("sessionExpired");
        }
        reject(error);
      });
  })
}
export function getDriverOrderItem(id) {
  return new Promise(function(resolve, reject) {
    console.log("place order " + localStorage.getItem("JSTOKEN"));
    EventBus.$emit("showLoading", true);
    axios.get(process.env.ROOT_API + 'driver/order?id=' + id, {
      headers:{
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function(response) {
      EventBus.$emit("showLoading", false);
      let data = response['data'];
      console.log(data);
      resolve(data);
    })
      .catch(error=>{
        EventBus.$emit("showLoading", false);
        console.log("error to update");
        console.log(error.response);
        if(error.response != undefined && error.response.data != undefined && error.response.data.status != undefined && error.response.data.status == 403) {
          EventBus.$emit("sessionExpired");
        }
        reject(error);
      });
  })
}
export function updateDriverOrderItem(order) {
  return new Promise(function(resolve, reject) {
    console.log("place order " + localStorage.getItem("JSTOKEN"));
    EventBus.$emit("showLoading", true);
    axios.post(process.env.ROOT_API + 'driver/order', JSON.stringify(order), {
      headers:{
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function(response) {
      EventBus.$emit("showLoading", false);
      let data = response['data'];
      console.log(data);
      resolve(data);
    })
      .catch(error=>{
        EventBus.$emit("showLoading", false);
        console.log("error to update");
        console.log(error.response);
        if(error.response != undefined && error.response.data != undefined && error.response.data.status != undefined && error.response.data.status == 403) {
          EventBus.$emit("sessionExpired");
        }
        reject(error);
      });
  })
}

export function updateDriverOrderChildItem(item) {
  return new Promise(function(resolve, reject) {
    console.log("place order " + localStorage.getItem("JSTOKEN"));
    EventBus.$emit("showLoading", true);
    axios.post(process.env.ROOT_API + 'driver/order/item', JSON.stringify(item), {
      headers:{
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function(response) {
      EventBus.$emit("showLoading", false);
      let data = response['data'];
      console.log(data);
      resolve(data);
    })
      .catch(error=>{
        EventBus.$emit("showLoading", false);
        console.log("error to update");
        console.log(error.response);
        if(error.response != undefined && error.response.data != undefined && error.response.data.status != undefined && error.response.data.status == 403) {
          EventBus.$emit("sessionExpired");
        }
        reject(error);
      });
  })
}
export function enterWeight(id, weight) {
  return new Promise(function(resolve, reject) {
    console.log("Update weight ");
    EventBus.$emit("showLoading", true);
    axios.get(process.env.ROOT_API + 'driver/order/weight?id=' + id + "&weight="+weight, {
      headers:{
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function(response) {
      EventBus.$emit("showLoading", false);
      let data = response['data'];
      console.log(data);
      resolve(data);
    })
      .catch(error=>{
        EventBus.$emit("showLoading", false);
        console.log("error to update");
        console.log(error.response);
        if(error.response != undefined && error.response.data != undefined && error.response.data.status != undefined && error.response.data.status == 403) {
          EventBus.$emit("sessionExpired");
        }
        reject(error);
      });
  })
}
export function deleteMemo(id) {
  return new Promise(function (resolve, reject) {
    console.log("Delete memo ")
    EventBus.$emit("showLoading", true);
    axios.delete(process.env.ROOT_API + 'driver/note?id='+id, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      EventBus.$emit("showLoading", false);
      let data = response['data'];
      resolve(data);
    })
      .catch(error => {
        EventBus.$emit("showLoading", false);
        console.log("error to update");
        console.log(error.response);
        if(error.response != undefined && error.response.data != undefined && error.response.data.status != undefined && error.response.data.status == 403) {
          EventBus.$emit("sessionExpired");
        }
        reject(error);
      });
  })
}
export function getMerchants() {
  return new Promise(function(resolve, reject) {
    console.log("place order " + localStorage.getItem("JSTOKEN"));
    EventBus.$emit("showLoading", true);
    axios.get(process.env.ROOT_API + 'driver/merchants', {
      headers:{
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function(response) {
      EventBus.$emit("showLoading", false);
      let data = response['data'];
      console.log(data);
      resolve(data);
    })
      .catch(error=>{
        EventBus.$emit("showLoading", false);
        console.log("error to update");
        console.log(error.response);
        if(error.response != undefined && error.response.data != undefined && error.response.data.status != undefined && error.response.data.status == 403) {
          EventBus.$emit("sessionExpired");
        }
        reject(error);
      });
  })
}

export function getDrivers() {
  return new Promise(function(resolve, reject) {
    console.log("place order " + localStorage.getItem("JSTOKEN"));
    EventBus.$emit("showLoading", true);
    axios.get(process.env.ROOT_API + 'admin/users/drivers', {
      headers:{
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function(response) {
      EventBus.$emit("showLoading", false);
      let data = response['data'];
      console.log(data);
      resolve(data);
    })
      .catch(error=>{
        EventBus.$emit("showLoading", false);
        console.log("error to update");
        console.log(error.response);
        if(error.response != undefined && error.response.data != undefined && error.response.data.status != undefined && error.response.data.status == 403) {
          EventBus.$emit("sessionExpired");
        }
        reject(error);
      });
  })
}
export function getDriverOrders(driverId, date) {
  return new Promise(function(resolve, reject) {
    console.log("place order " + localStorage.getItem("JSTOKEN"));
    EventBus.$emit("showLoading", true);
    axios.get(process.env.ROOT_API + 'admin/driver/' + driverId + '/orders?date='+date, {
      headers:{
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function(response) {
      EventBus.$emit("showLoading", false);
      let data = response['data'];
      console.log(data);
      resolve(data);
    })
      .catch(error=>{
        EventBus.$emit("showLoading", false);
        console.log("error to update");
        console.log(error.response);
        if(error.response != undefined && error.response.data != undefined && error.response.data.status != undefined && error.response.data.status == 403) {
          EventBus.$emit("sessionExpired");
        }
        reject(error);
      });
  })
}
export function getDriverCategories() {
  return new Promise(function(resolve, reject) {
    console.log("getCategories " + localStorage.getItem("JSTOKEN"));
    axios.get(process.env.ROOT_API + 'driver/categories', {
      headers:{
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function(response) {
      let data = response['data'];
      console.log(data);
      resolve(data);
    })
      .catch(error=>{
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error);
      });
  })
}



// WEBPACK FOOTER //
// ./src/api/drivers.js